import EmptyCollectionsImage from "@/assets/images/empty-collections.svg?react";
import EmptySharingImage from "@/assets/images/empty-sharing-collections.svg?react";
import EmptySearchImage from "@/assets/images/empty-search.svg?react";
import {
  EmptyContainer,
  EmptyText,
  EmptyTextContainer,
  EmptyTextSubtitle,
} from "@/components/styling/empty";
import { useTabPageStore } from "@/hooks/useTabPageStore";
import { MDSButton, MDSButtonVariant } from "@/mds";
import { LensKind } from "@/modules/lenses/types";
import { observer } from "mobx-react-lite";

export const CollectionsListPageListEmpty = observer(function CollectionsListPageListEmpty() {
  const page = useTabPageStore("collectionsListPage");

  if (page.hasAnyFilters) {
    return (
      <EmptyContainer>
        <EmptySearchImage />
        <EmptyText>No results match your selected filters</EmptyText>
        <MDSButton onClick={() => page.clearAllFilters()}>Clear filters</MDSButton>
      </EmptyContainer>
    );
  }

  if (page.lens === LensKind.SharedWithMe) {
    return (
      <EmptyContainer>
        <EmptySharingImage />
        <EmptyText>Collections shared with you appear here</EmptyText>
      </EmptyContainer>
    );
  }

  return (
    <EmptyContainer>
      <EmptyCollectionsImage />
      <EmptyTextContainer>
        <EmptyText>No collections yet</EmptyText>
        <EmptyTextSubtitle>Collections help you organize and share your notes</EmptyTextSubtitle>
      </EmptyTextContainer>
      <MDSButton
        variant={MDSButtonVariant.Contrast}
        onClick={() => page.handleCreateNewCollection()}
      >
        Create collection
      </MDSButton>
    </EmptyContainer>
  );
});
